import React, { useMemo } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { AvatarVerify } from '../OurTeam/AvatarVerify';
import { contrastColors, trimAddress } from '../../utils/parser';
import { IUser } from '../../providers/User/useUser';
import { Color } from 'src/theme/color';

enum Nickname {
	YES,
	NO,
}

export const AccountResult = ({ data }: { data: IUser }) => {
	const nameOptions: { [p: number]: () => React.ReactNode } = {
		[Nickname.YES]: () => (
			<>
				<Text
					color="white"
					fontSize="20px"
					lineHeight="24px"
				>
					{data.nickname}
				</Text>
				<Text
					fontSize="12px"
					lineHeight="14px"
					letterSpacing="0.07em"
					color={Color.BACKGROUND_TERTIARY}
				>
					{trimAddress(data.address)}
				</Text>
			</>
		),
		[Nickname.NO]: () => (
			<Text
				color="backgroundTertiary"
				fontSize="20px"
				lineHeight="24px"
			>
				{trimAddress(data.address)}
			</Text>
		),
	};

	const connectName = useMemo(() => (data.nickname ? Nickname.YES : Nickname.NO), [data.nickname]);

	return (
		<Flex
			_hover={{ background: 'rgba(0,0,0, .1)', borderRadius: '5px' }}
			as={Link}
			to={`/user/${data.address.toLowerCase()}`}
		>
			<AvatarVerify
				isCompact
				avatar={data.avatar}
				name={data.nickname.slice(0, 1)}
				isVerified={data.verified}
				bg={data.color}
				color={contrastColors(data.color, '#ffffff') > 3.1 ? 'white' : 'black'}
			/>
			<Flex
				flexDirection="column"
				gridGap="8px"
				ml="24px"
				justifyContent="center"
			>
				{nameOptions[connectName]()}
			</Flex>
		</Flex>
	);
};
